// Hook odpowiedzialny za wywołanie akcji GET

import { axios } from 'api';
import qs from 'query-string';
import { useQuery, UseQueryOptions } from 'react-query';
import { IPaginationResponse, ICommandResponseError as IError } from 'plugins/api/types';

import { loadDataUrlParser } from 'plugins/util/parser';

// bazowy url
const stripQueryParams = (url: string) => {
  return url.split('?')[0];
};

// czy bazowy url jest poprawny (nie zawiera null lub undefined)
const isValidUrl = (str: string) => {
  if (
    stripQueryParams(str) &&
    !stripQueryParams(str).match('undefined') &&
    !stripQueryParams(str).match('null')
  ) {
    return true;
  }
};

// parametry requestu do api
export type IRequest = object;

// typ zwracanych danych
type IResponse = IPaginationResponse<any>;

const loadData = (command_url: string, params?: IRequest): Promise<IResponse> => {
  // użycie parsera do pobierania parametrów z url
  const loadDataUrl = loadDataUrlParser(command_url || '', {
    ...qs.parse(window.location.search)
  });

  if (loadDataUrl && isValidUrl(loadDataUrl)) {
    return axios.get(loadDataUrl, { params });
  }

  return new Promise(() => null);
};

export const useLoadData = (
  command_url: string,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>([command_url, params], () => loadData(command_url, params), {
    ...options,
    cacheTime: 0
  });
